module.exports = __webpack_public_path__ + "static/media/20_000021.1273043b.jpg";